// extracted by mini-css-extract-plugin
module.exports = {"root":"DefaultLayout_root__3sASy","content":"DefaultLayout_content__3VLul"};